export default {
  email: 'Email',
  name: 'Name',
  phone: 'Phone',
  phoneNumber: 'Phone number',
  encrypt: 'All data is encrypted and transmitted directly to our specialists',
  readyToSend: 'Ready to send',
  sendRequest: 'Send request',
  enterPhoneNumber: 'Enter phone number',
  next: 'Next',
  enterEmail: 'Enter e-mail'
}
